import {
  DownloadEngine,
  DownloadObjectType,
  DownloadPlatformType,
  IDownLoadMenu,
} from './download';
import { INews } from './news';

export interface ICos {
  readonly bucket: string;
  readonly region: string;
}

// 配置项
export interface IDownloadCenterConfig {
  readonly Engine: DownloadEngine;
  readonly ObjectType: DownloadObjectType;
  readonly Platform: DownloadPlatformType;
  readonly Cos: ICos;
  readonly UploadDir: string;
}

export interface IPackage {
  readonly file: string;
  readonly size: number;
}

export interface IEngineJson {
  readonly gdkVersion: string[];
  readonly pssdkVersion: string[];
  readonly package: IPackage[];
  readonly platform: number[];
  readonly type: DownloadEngine;
  readonly version: string[];
}

export interface IVersionItem {
  readonly CreateTime: string;
  readonly CreatorID: number;
  readonly Description: string;
  readonly DocLink: string;
  readonly EngineJson: IEngineJson[];
  readonly ModifierID: number;
  readonly ModifyTime: string;
  readonly ObjectID: number;
  readonly Status: number;
  readonly Version: string;
  readonly id: number;
  readonly SubVersions?: IVersionItem[];
  readonly Tag?: string;
}

// 下载物展示列表
export interface IDownloadCenterObject {
  readonly Description: string;
  readonly DocLink: string;
  readonly Name: string;
  readonly VersionItem: IVersionItem;
  readonly Status: number;
  readonly StudioWhitelistArray: string[];
  readonly Type: number;
  readonly id: number;
  readonly SubObject?: IDownLoadMenu[];
}

interface IEngine {
  readonly gdkVersion: string;
  readonly pssdkVersion: string;
  readonly type: DownloadEngine;
  readonly version: string;
  readonly windowVersion?: string;
  readonly macosVersion?: string;
  readonly androidVersion?: string;
  readonly iosVersion?: string;
}
export interface ISdkInfo {
  readonly versionID: string;
  readonly engine: IEngine;
  readonly subVersionTags?: string[];
  readonly platforms?: DownloadPlatformType[];
}

// 创建下载任务
export interface IDownloadCenterDownload {
  readonly StudioID?: string;
  readonly GameID?: string;
  readonly EnvID?: number;
  readonly SdkInfo: ISdkInfo[];
}

export enum DownloadTaskStep {
  Initialization = 'initialization',
  DownRemoteZip = 'downRemoteZip',
  Unzip = 'unzip',
  WriteConfig = 'writeConfig',
  MakeZip = 'makeZip',
  UploadRemote = 'uploadRemote',
  PushCDNCache = 'pushCDNCache',
  DescribePushTask = 'describePushTask',
  ResetWorkspace = 'resetWorkspace',
  MakingPackage = 'makingPackage',
}

export interface IDownloadNews extends INews {
  site?: string;
  allSiteRecord?: IDownloadNews[];
}
